import {getFunctions,httpsCallable} from 'firebase/functions';
export const gestionarHistorial=async data=>(await httpsCallable(getFunctions(),'gestionarHistorial',{timeout:540000})(data)).data;
